import { Dispatch, SetStateAction } from 'react';
import { PersonaSize } from '@fluentui/react';
import {
  TeamWidgetEmployeeContainer,
  TeamWidgetPersonaContainer,
  TeamWidgetPersona,
  TeamWidgetListItem,
  TeamWidgetListItemDismiss,
} from './styles/TeamWidgetSection.styled';
import { Employee } from 'src/tabs/hooks/useGetAllUsers';
import { analyticsEventSend } from 'src/utils/analytics/analyticsEventSend';
import {
  generateReactKey,
  KeyRoots,
} from 'src/utils/generateUniqueReactKey/generateUniqueReactKey';

export interface ColorCodedEmployee extends Employee {
  backgroundPersona: string;
  colorPersona: string;
}

interface TeamWidgetSectionProps {
  team: Array<ColorCodedEmployee>;
  setTeam: Dispatch<SetStateAction<Array<ColorCodedEmployee>>>;
}

export const TeamWidgetSection = ({
  team,
  setTeam,
}: TeamWidgetSectionProps) => {
  const removeHandler = (index: number) => {
    const newTeam = [...team];
    newTeam.splice(index, 1);
    setTeam(newTeam);
  };

  return (
    <TeamWidgetEmployeeContainer>
      <TeamWidgetPersonaContainer>
        {team.map((teamMember, index) => {
          return (
            <TeamWidgetListItem
              key={generateReactKey(
                KeyRoots.TIME_OFF_TEAM_WIDGET_PERSONA,
                index
              )}
            >
              <TeamWidgetPersona
                backgroundPersonal={teamMember.backgroundPersona}
                colorPersona={teamMember.colorPersona}
                text={teamMember.new_name}
                size={PersonaSize.size32}
                showOverflowTooltip={false}
              />
              <TeamWidgetListItemDismiss
                onClick={() => {
                  removeHandler(index);
                  analyticsEventSend(
                    'Removed a user from team widget tracker from search box'
                  );
                }}
              />
            </TeamWidgetListItem>
          );
        })}
      </TeamWidgetPersonaContainer>
    </TeamWidgetEmployeeContainer>
  );
};
